/** Keep the original workshop's saved browser session when entering via the new catalog. */
export function lessonSessionKey(id: string | null, version: string | null): string {
  if (!id || (id === 'grade7-linear-equations' && (!version || version === 'grade7-linear-equations@1.0.0')))
    return 'enactry.internal.session.v1';
  return `enactry.lesson.session.v1:${id}:${version ?? 'current'}`;
}
